var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64499 12C4.64499 7.93793 7.93793 4.64499 12 4.64499C16.0602 4.64938 19.3506 7.93976 19.355 12C19.355 16.062 16.062 19.355 12 19.355C7.93793 19.355 4.64499 16.062 4.64499 12ZM6.64499 12C6.64499 14.9575 9.04251 17.355 12 17.355C14.9561 17.3517 17.3517 14.9561 17.355 12C17.355 9.04251 14.9575 6.64499 12 6.64499C9.04251 6.64499 6.64499 9.04251 6.64499 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.467C12.5523 3.467 13 3.01928 13 2.467V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2.467C11 3.01928 11.4477 3.467 12 3.467Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.552 5.966C4.80307 6.22595 5.17487 6.33021 5.5245 6.23869C5.87413 6.14718 6.14718 5.87413 6.23869 5.5245C6.33021 5.17487 6.22595 4.80307 5.966 4.552L4.929 3.515C4.53662 3.13602 3.91291 3.14144 3.52718 3.52718C3.14144 3.91291 3.13602 4.53662 3.515 4.929L4.552 5.966Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.467 11H1C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13H2.467C3.01928 13 3.467 12.5523 3.467 12C3.467 11.4477 3.01928 11 2.467 11Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.552 18.034L3.515 19.071C3.25504 19.3221 3.15079 19.6939 3.2423 20.0435C3.33382 20.3931 3.60686 20.6662 3.95649 20.7577C4.30612 20.8492 4.67792 20.745 4.929 20.485L5.966 19.448C6.22596 19.1969 6.33021 18.8251 6.2387 18.4755C6.14718 18.1259 5.87414 17.8528 5.52451 17.7613C5.17488 17.6698 4.80307 17.7741 4.552 18.034Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.533C11.4477 20.533 11 20.9807 11 21.533V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V21.533C13 20.9807 12.5523 20.533 12 20.533Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.448 18.034C19.0556 17.655 18.4319 17.6605 18.0462 18.0462C17.6605 18.4319 17.655 19.0556 18.034 19.448L19.071 20.485C19.4634 20.864 20.0871 20.8586 20.4728 20.4728C20.8586 20.0871 20.864 19.4634 20.485 19.071L19.448 18.034Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11H21.533C20.9807 11 20.533 11.4477 20.533 12C20.533 12.5523 20.9807 13 21.533 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.741 6.259C19.0062 6.25894 19.2605 6.15354 19.448 5.966L20.485 4.929C20.864 4.53662 20.8585 3.91291 20.4728 3.52718C20.0871 3.14144 19.4634 3.13602 19.071 3.515L18.034 4.552C17.7481 4.83799 17.6626 5.26803 17.8173 5.64165C17.9721 6.01527 18.3366 6.25891 18.741 6.259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherSun);
export default __webpack_public_path__ + "static/media/weatherSun.51189d97.svg";
export { ForwardRef as ReactComponent };